// 호스트명에서 ekmtc 도메인 끝부분 반환 ('.com', '.com.cn' 등, ekmtc 도메인이 아니면 undefined)
export function ekmtcTld (hostname) {
  return ((hostname || location.hostname).match(/ekmtc((?:\.[a-z]+)+)$/i) || [])[1]
}

// 현재 접속 호스트의 ekmtc 도메인 끝부분(.com / .com.cn ...)을 추출해
// 백엔드 URL 의 도메인 끝부분에 동일하게 적용한다.
export function toServiceDomain (url) {
  if (!url) return url
  // 현재 호스트에서 'ekmtc' 뒤 TLD 추출 (www.ekmtc.com → '.com', www.ekmtc.com.cn → '.com.cn')
  const m = location.host.match(/ekmtc((?:\.[a-z]+)+)/i)
  if (!m) return url // ekmtc 도메인이 아니면(localhost 등) 그대로
  // 백엔드 URL 의 ekmtc 호스트 TLD 를 현재 호스트의 TLD 로 치환
  return url.replace(/ekmtc(?:\.[a-z]+)+/i, 'ekmtc' + m[1])
}
